<template>
    <div v-if="$store.state.connected" class="dashboard">
        <HomeC/>
    </div>
</template>

<script>
    import HomeC from "@/components/Home/Home.vue";
    import router from "../router/index.js";
    
    export default {
        name: "Home",
        data(){
            return{
            }
        },
        components: {
            HomeC,
        },
        created: function() {
          // this.$store.state.commit('increment')
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>